<template>
  <div class="steps">
    <div class="pre">
      <div v-show="index > 0" @click="bindPre" class="back">
        <span class="iconfont icon-fanhui"></span><span>上一题</span>
      </div>
    </div>
    <div class="content">
      <div
        class="line"
        :style="{ width: progress, background: theme.stepColor }"
      ></div>
    </div>
    <div class="cur">{{ progress }}</div>
  </div>
</template>
<script>
export default {
  props: {
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 1
    },
    backColor: {
      type: String,
      default: 'linear-gradient(270deg, #BA8CE0 0%, #DEC0F2 100%)'
    }
  },
  computed: {
    progress() {
      let res = Math.ceil(((this.index + 1) / this.total) * 100)
      if (res < 0) {
        res = 0
      }
      if (res > 100) {
        res = 100
      }
      return res + '%'
    }
  },
  methods: {
    //上一题
    bindPre() {
      if (this.index > 0) {
        this.$emit('pre')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.steps {
  padding: 0px 10px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;

  .pre {
    width: 56px;
    font-size: 13px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    color: rgba(38, 47, 68, 0.5);
    line-height: 20px;
  }

  .back {
    white-space: nowrap;
  }

  .content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    margin: 0 20px;
    height: 16px;
    background: #ffffff;
    border-radius: 8px;
    background-color: rgba(39, 36, 60, 0.1);

    .line {
      height: 100%;
      width: 0%;
      border-radius: 8px;
      transition: width 0.2s linear;
    }
  }

  .cur {
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(58, 55, 82, 0.3);
    line-height: 18px;
    margin-right: 10px;
  }
}
</style>
